import { useEffect, useState } from "react";

import { db } from "../firebase/config";
import getAccess from "../helpers/getAccess";

export interface TicketProps {
  code: string;
  code2?: string;
  email: string;
  firstname: string;
  lastname: string;
  order: string;
  status: string;
  type: string;
  access: string;
}

const useTickets = () => {
  const [tickets, setTickets] = useState<TicketProps[]>([]);

  useEffect(() => {
    const fetch = async () => {
      db.collection("tickets").onSnapshot(async (qs) => {
        const tickets = await Promise.all(
          qs.docs.map(async (doc) => {
            const data = doc.data();

            const {
              code,
              code2,
              email,
              firstname,
              lastname,
              order,
              status,
              type,
            } = data;

            const ticket = {
              code: code.toString(),
              code2: code2.toString(),
              email,
              firstname: firstname || "",
              lastname: lastname || "",
              order,
              status,
              type,
              access: getAccess(type),
            };

            return ticket;
          })
        );

        setTickets(tickets);
      });
    };

    fetch();
  }, []);

  return tickets;
};

export default useTickets;
